import React from "react"
import Logo from "../components/image"

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="row position-relative d-flex justify-content-start justify-content-md-end pt-5 pb-5" style={{margin: "auto"}}>
          <div className="footer__logo mb-5 mb-md-0  align-self-start ">
            <Logo />
          </div>
          <div className="footer__content mr-0 mr-md-5 ">
            <h3 className="">DANE KONTAKTOWE</h3>
            <div className="contact-data mt-5 ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                height="512px"
                viewBox="0 0 512.00069 512"
                width="512px"
              >
                <g>
                  <path
                    d="m316 260c-5.519531 0-10 4.480469-10 10s4.480469 10 10 10 10-4.480469 10-10-4.480469-10-10-10zm0 0"
                    data-original="#000000"
                    class="active-path"
                    data-old_color="#000000"
                    fill="#F5F5F5"
                  />
                  <path
                    d="m102.167969 369.785156-100 126c-2.386719 3.003906-2.839844 7.109375-1.171875 10.5625 1.667968 3.457032 5.167968 5.652344 9.003906 5.652344h492c3.835938 0 7.335938-2.195312 9.003906-5.652344 1.671875-3.453125 1.214844-7.558594-1.171875-10.5625l-100-126c-1.894531-2.390625-4.78125-3.785156-7.832031-3.785156h-87.597656l74.785156-117.296875c17.542969-26.300781 26.8125-56.972656 26.8125-88.703125 0-88.222656-71.773438-160-160-160s-160 71.777344-160 160c0 31.730469 9.269531 62.398438 26.8125 88.703125l74.785156 117.296875h-87.597656c-3.050781 0-5.933594 1.394531-7.832031 3.785156zm-37.335938 79.214844h60.464844l-34.125 43h-60.46875zm145.519531-63 27.414063 43h-71.0625l34.128906-43zm91.300782 0h9.519531l34.125 43h-71.058594zm59.519531 63 34.125 43h-278.59375l34.128906-43zm59.660156 43-34.128906-43h60.46875l34.125 43zm10.464844-63h-60.464844l-34.128906-43h60.46875zm-291.789063-191.3125c-15.378906-23.023438-23.507812-49.886719-23.507812-77.6875 0-77.195312 62.804688-140 140-140s140 62.804688 140 140c0 27.800781-8.128906 54.664062-23.503906 77.6875-.042969.058594-.078125.117188-.117188.175781-6.566406 10.300781-111.320312 174.605469-116.378906 182.535157-12.722656-19.957032-103.421875-162.214844-116.378906-182.535157-.035156-.058593-.074219-.117187-.113282-.175781zm35.789063 148.3125-34.125 43h-60.46875l34.128906-43zm0 0"
                    data-original="#000000"
                    class="active-path"
                    data-old_color="#000000"
                    fill="#F5F5F5"
                  />
                  <path
                    d="m256 260c54.898438 0 100-44.457031 100-100 0-55.140625-44.859375-100-100-100s-100 44.859375-100 100c0 55.558594 45.117188 100 100 100zm0-180c44.113281 0 80 35.886719 80 80 0 44.523438-36.175781 80-80 80-43.835938 0-80-35.476562-80-80 0-44.113281 35.886719-80 80-80zm0 0"
                    data-original="#000000"
                    class="active-path"
                    data-old_color="#000000"
                    fill="#F5F5F5"
                  />
                  <path
                    d="m298.121094 294.125c-4.726563-2.851562-10.875-1.328125-13.726563 3.402344l-36.960937 61.320312c-2.851563 4.730469-1.328125 10.875 3.402344 13.726563 4.75 2.863281 10.886718 1.308593 13.726562-3.402344l36.960938-61.320313c2.851562-4.730468 1.328124-10.875-3.402344-13.726562zm0 0"
                    data-original="#000000"
                    class="active-path"
                    data-old_color="#000000"
                    fill="#F5F5F5"
                  />
                </g>{" "}
              </svg>
              <p className="ml-5">
                Pojedzone <br />
                Dąbrówka 87g 37-410 Ulanów
              </p>
            </div>
            <div className="contact-data mt-3">
              <svg
                version="1.1"
                id="Capa_1"
                x="0px"
                y="0px"
                viewBox="0 0 512.001 512.001"
                width="512px"
                height="512px"
              >
                <g>
                  <g>
                    <g>
                      <path
                        d="M324.259,0c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533c94.106,0,170.667,76.561,170.667,170.667    c0,4.71,3.823,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533C511.992,84.216,427.777,0,324.259,0z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#F5F5F5"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M324.259,51.2c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533c65.877,0,119.467,53.589,119.467,119.467    c0,4.71,3.823,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533C460.792,112.453,399.548,51.2,324.259,51.2z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#F5F5F5"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M324.259,102.4c-4.71,0-8.533,3.823-8.533,8.533s3.823,8.533,8.533,8.533c37.641,0,68.267,30.626,68.267,68.267    c0,4.71,3.823,8.533,8.533,8.533c4.719,0,8.533-3.823,8.533-8.533C409.592,140.681,371.311,102.4,324.259,102.4z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#F5F5F5"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M461.765,320.214c-23.219-3.055-46.114-8.755-68.045-16.922c-21.239-7.962-45.372-2.825-61.534,13.124l-26.974,26.914    c-56.559-33.348-103.808-80.503-137.233-136.951l26.991-26.931c15.957-16.102,21.111-40.209,13.133-61.397    c-8.183-21.896-13.892-44.74-16.964-67.994C187.051,21.231,162.091-0.111,132.916,0H58.258c-1.741,0-3.482,0.085-5.205,0.239    C37.547,1.639,23.51,8.986,13.534,20.916C3.559,32.854-1.169,47.958,0.248,63.582c8.269,77.722,35.149,153.472,77.688,219.008    c38.622,60.655,91.162,113.092,151.876,151.595c65.417,42.342,140.962,69.163,218.641,77.585c1.758,0.154,3.524,0.23,5.299,0.23    c0.051,0,0.102,0,0.162,0c32.154-0.137,58.197-26.351,58.069-58.411v-74.402C512.658,349.688,491.119,324.344,461.765,320.214z     M494.917,378.88c0,0.068,0,0.145,0,0.213v74.539c0.085,22.682-18.338,41.216-41.062,41.31c-1.331-0.051-2.611-0.051-3.738-0.154    c-74.871-8.124-147.849-34.031-211.106-74.974c-58.675-37.214-109.397-87.834-146.722-146.458    C51.166,210.006,25.208,136.841,17.229,61.91c-0.99-10.94,2.347-21.606,9.404-30.046s16.981-13.636,27.955-14.626    c1.22-0.111,2.441-0.171,3.669-0.171h74.735c0.137,0,0.273,0,0.41,0c20.446,0,37.965,15.147,40.823,35.302    c3.234,24.448,9.25,48.563,17.894,71.68c5.641,14.984,1.997,32.017-9.242,43.358l-31.607,31.539    c-2.731,2.722-3.294,6.921-1.391,10.266c36.164,63.488,88.909,116.122,152.508,152.209c3.345,1.903,7.526,1.323,10.24-1.382    l31.573-31.505c11.409-11.255,28.501-14.882,43.537-9.25c23.142,8.619,47.3,14.635,71.714,17.843    C480.188,340.045,495.437,357.991,494.917,378.88z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#F5F5F5"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M128.001,34.134H58.258c-0.717,0-1.425,0.034-2.133,0.102c-8.695,0.785-14.012,5.717-16.401,8.576    c-1.92,2.295-6.306,8.559-5.538,17.161c3.226,30.268,9.062,59.716,17.365,87.535c1.109,3.695,4.497,6.093,8.175,6.093    c0.811,0,1.63-0.111,2.449-0.358c4.514-1.348,7.083-6.101,5.734-10.615c-8.004-26.812-13.636-55.228-16.734-84.318    c-0.196-2.167,1.212-4.036,1.647-4.565c0.7-0.836,2.261-2.278,5.436-2.543h69.726c0.009,0,0.009,0,0.009,0    c4.71,0,8.533-3.814,8.533-8.525C136.534,37.965,132.711,34.134,128.001,34.134z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#F5F5F5"
                      />
                    </g>
                  </g>
                  <g>
                    <g>
                      <path
                        d="M469.325,375.467c-4.71,0-8.533,3.823-8.533,8.533l-0.009,69.623c0.009,1.92-0.725,3.729-2.065,5.077    c-1.34,1.348-3.115,2.091-4.804,2.099l-0.785-0.017c-29.158-3.166-57.335-8.781-83.746-16.691    c-4.497-1.357-9.267,1.212-10.624,5.726c-1.357,4.514,1.212,9.267,5.726,10.624c27.401,8.209,56.61,14.029,86.955,17.323    c0.7,0.068,2.125,0.102,2.33,0.102c6.46-0.026,12.518-2.56,17.067-7.142c4.548-4.591,7.04-10.684,7.014-17.135L477.859,384    C477.859,379.29,474.036,375.467,469.325,375.467z"
                        data-original="#000000"
                        class="active-path"
                        data-old_color="#000000"
                        fill="#F5F5F5"
                      />
                    </g>
                  </g>
                </g>{" "}
              </svg>
             <a style={{color: "whitesmoke"}} href="tel:+667102228"> <p style={{color: "whitesmoke"}} className="ml-5">667-102-228</p></a>
            </div>
            <div className="contact-data mt-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                enable-background="new 0 0 482 482"
                height="512px"
                viewBox="0 0 482 482"
                width="512px"
              >
                <g>
                  <path
                    d="m153.364 272.636c3.515 3.515 3.515 9.213 0 12.728l-87.75 87.75c-1.757 1.757-4.061 2.636-6.364 2.636-7.947 0-12.049-9.679-6.364-15.364l87.75-87.75c3.515-3.515 9.213-3.515 12.728 0zm188 0c-3.516-3.515-9.213-3.515-12.729 0-3.515 3.515-3.515 9.213 0 12.728l87.75 87.75c3.516 3.515 9.213 3.515 12.729 0 3.515-3.515 3.515-9.213 0-12.728zm140.636-167.636v272c0 27.019-21.981 49-49 49h-384c-27.019 0-49-21.981-49-49v-272c0-27.019 21.981-49 49-49h384c27.019 0 49 21.981 49 49zm-18 0c0-17.094-13.906-31-31-31h-384c-17.093 0-31 13.906-31 31v30.699l205.963 100.022c10.827 5.258 23.246 5.259 34.074 0l144.012-69.937c4.475-2.171 9.856-.306 12.027 4.164 2.172 4.471.307 9.856-4.164 12.027l-144.012 69.938c-15.824 7.684-33.976 7.685-49.801 0l-198.099-96.204v221.291c0 17.094 13.907 31 31 31h384c17.094 0 31-13.906 31-31z"
                    data-original="#000000"
                    class="active-path"
                    data-old_color="#000000"
                    fill="#F5F5F5"
                  />
                </g>{" "}
              </svg>
              <p className="ml-5">kontakt.pojedzone@gmail.com</p>
            </div>
          </div>
          <div className="footer__hours mt-5 mt-md-0 ml-7">
              <h3>GODZINY OTWARCIA</h3>
              <p className="mt-5">PONIEDZIAŁEK : ZAMKNIĘTE</p>
              <p className="mt-5">WTOREK - NIEDZIELA : 13.00 - 21.00</p>
             <a href="https://www.facebook.com/Pojedzone-101513308289766" target="_blank" rel="noopener noreferrer"><svg  xmlns="http://www.w3.org/2000/svg" height="512px" viewBox="0 0 512 512" width="512px" className="mt-5"><g><path d="m426.578125 75.421875h-67.320313c-52.402343 0-95.035156 42.632813-95.035156 95.035156v56.816407h-53.273437c-5.519531 0-10 4.476562-10 10v76.9375c0 5.523437 4.480469 10 10 10h53.273437v167.789062h-234.222656c-5.515625 0-10-4.484375-10-10v-452c0-5.515625 4.484375-10 10-10h20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-20c-16.542969 0-30 13.457031-30 30v452c0 16.542969 13.457031 30 30 30h244.222656c5.523438 0 10-4.476562 10-10v-187.789062c0-5.523438-4.476562-10-10-10h-53.269531v-56.941407h53.269531c5.523438 0 10-4.476562 10-10v-66.8125c0-41.375 33.660156-75.039062 75.039063-75.039062h57.320312v56.9375h-57.320312c-9.8125 0-18.101563 8.289062-18.101563 18.101562v66.8125c0 5.523438 4.476563 10 10 10h64.019532l-7.492188 56.941407h-56.527344c-5.519531 0-10 4.476562-10 10v187.789062c0 5.523438 4.480469 10 10 10h30.839844c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-20.839844v-167.789062h55.296875c5.019531 0 9.261719-3.722657 9.914063-8.695313l10.125-76.941406c.375-2.851563-.496094-5.730469-2.394532-7.894531-1.898437-2.167969-4.640624-3.40625-7.519531-3.40625h-65.417969v-54.914063h65.417969c5.523438 0 10-4.476563 10-10v-76.9375c-.003906-5.523437-4.480469-10-10.003906-10zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/><path d="m482 0h-352c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h352c5.515625 0 10 4.484375 10 10v452c0 5.515625-4.484375 10-10 10h-20c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h20c16.542969 0 30-13.457031 30-30v-452c0-16.542969-13.457031-30-30-30zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/><path d="m422.003906 492h-.007812c-5.523438 0-9.996094 4.476562-9.996094 10s4.480469 10 10.003906 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/><path d="m90.003906 20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-.007812c-5.523438 0-9.996094 4.476562-9.996094 10s4.480469 10 10.003906 10zm0 0" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/></g> </svg></a> 
          </div>
        </div>
        <div className="row footer-author d-flex justify-content-between ">
          <p style={{color: "whitesmoke"}} className="author mt-5">wykonanie PIOTR NAZARUK : 513-650-513</p>
          <p className="rights mt-5">   © {new Date().getFullYear()} Pojedzone all rights reserved</p>
        </div>
       
      </div>
    </footer>
  )
}

export default Footer
